import { onBeforeUnmount, provide, toValue, watch } from 'vue'

import { useNuxtApp } from '#app'
import { ANALYTICS_PAGE_TITLE_KEY, getAnalyticsPageTitleContext } from '@/utils/analyticsPageTitle'

export const usePageTitle = (pageTitle) => {
  const context = getAnalyticsPageTitleContext(useNuxtApp())
  const entryId = context.register(toValue(pageTitle))

  provide(ANALYTICS_PAGE_TITLE_KEY, {
    current: () => toValue(pageTitle),
  })

  const stopTitleWatch = watch(
    () => toValue(pageTitle),
    (title) => {
      context.update(entryId, title)
    },
    { flush: 'sync' }
  )

  onBeforeUnmount(() => {
    stopTitleWatch()
    context.unregister(entryId)
  })
}
